import AuditLogs from '@/views/audit-logs/audit-logs.vue'
import ShowAuditLog from '@/views/audit-logs/audit-logs-show.vue'
import { AuditLogsRouteNames } from '@/router/routes-names'

export const auditLogsRoutes = [
    {
        path: '/audit-logs',
        name: AuditLogsRouteNames.LIST,
        component: AuditLogs
    },
    {
        path: '/audit-logs/show/:id',
        name: AuditLogsRouteNames.SHOW,
        component: ShowAuditLog
    }
]
